import ResultInternal from 'components/ResultInternal';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

function parseQuery(queryString) {
  var query = {};
  var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}

export default function Result() {

  const [result, setResult] = useState(null);

  const location = useLocation();
  const query = parseQuery(location.search);
  const currentEmail = query.email;
  const id = query.id;

  useEffect(() => {
    fetch(`/api/result/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: currentEmail,
        id: id,
      }),
    }).then(response => response.json()).then((res) => {
      setResult(res);
      setTimeout(() => {
        window.parent.postMessage({
          type: 'send-email',
        }, "*");
      }, 200);
    });

    const observer = new ResizeObserver(() => {
      const bounds = document.body.getBoundingClientRect();
      window.parent.postMessage({
        type: 'set-bound',
        target: 'result',
        bounds,
      }, "*");
    });

    observer.observe(document.body);

  }, []);

  return <ResultInternal result={result} currentEmail={currentEmail} />
}
